import React, { lazy } from 'react';
const Footer = () => {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-navy-950 text-white" data-id="element-242">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-243">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12" data-id="element-244">
          {/* Logo and Company Info */}
          <div className="col-span-1 md:col-span-4" data-id="element-245">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jq92PGrktbCMyEbrUBGpE9/SS-Logomark_Ether.webp" alt="SmartSoda Badge Logo" className="h-20 mb-6" width="80" height="80" loading="lazy" decoding="async" data-id="element-246" />
            <p className="text-gray-400 text-sm leading-relaxed max-w-xs" data-id="element-247">
              Premium beverage solutions that are sustainable, delicious, and
              cost-effective. Transforming spaces one sip at a time.
            </p>
          </div>
          {/* Solutions Links */}
          <div className="col-span-1 md:col-span-4" data-id="element-248">
            <h3 className="text-lg font-semibold mb-6 text-white" data-id="element-249">
              Our Solutions
            </h3>
            <ul className="space-y-4" data-id="element-250">
              <li data-id="element-251">
                <a href="https://breakrooms.smartsoda.com" className="text-gray-400 hover:text-white transition-colors duration-200 text-sm flex items-center group" target="_blank" rel="noopener noreferrer" data-id="element-252">
                  <span className="mr-2 text-blue-500 group-hover:translate-x-1 transition-transform duration-200" data-id="element-253">
                    →
                  </span>
                  Breakrooms
                </a>
              </li>
              <li data-id="element-254">
                <a href="https://restaurant.smartsoda.com" className="text-gray-400 hover:text-white transition-colors duration-200 text-sm flex items-center group" target="_blank" rel="noopener noreferrer" data-id="element-255">
                  <span className="mr-2 text-blue-500 group-hover:translate-x-1 transition-transform duration-200" data-id="element-256">
                    →
                  </span>
                  Restaurants
                </a>
              </li>
              <li data-id="element-257">
                <a href="https://spa.smartsoda.com" className="text-gray-400 hover:text-white transition-colors duration-200 text-sm flex items-center group" target="_blank" rel="noopener noreferrer" data-id="element-258">
                  <span className="mr-2 text-blue-500 group-hover:translate-x-1 transition-transform duration-200" data-id="element-259">
                    →
                  </span>
                  Spas
                </a>
              </li>
              <li data-id="element-260">
                <a href="https://showroom.smartsoda.com" className="text-gray-400 hover:text-white transition-colors duration-200 text-sm flex items-center group" target="_blank" rel="noopener noreferrer" data-id="element-261">
                  <span className="mr-2 text-blue-500 group-hover:translate-x-1 transition-transform duration-200" data-id="element-262">
                    →
                  </span>
                  Showrooms
                </a>
              </li>
            </ul>
          </div>
          {/* Contact Info */}
          <div className="col-span-1 md:col-span-4" data-id="element-263">
            <h3 className="text-lg font-semibold mb-6 text-white" data-id="element-264">
              Get in Touch
            </h3>
            <div className="space-y-4" data-id="element-265">
              <div className="flex items-start" data-id="element-266">
                <svg className="h-5 w-5 text-blue-500 mt-0.5 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-267">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" data-id="element-268" />
                </svg>
                <a href="mailto:office@smartsoda.com" className="text-gray-400 hover:text-white transition-colors duration-200 text-sm" data-id="element-269">
                  office@smartsoda.com
                </a>
              </div>
            </div>
          </div>
        </div>
        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-800" data-id="element-270">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0" data-id="element-271">
            <p className="text-gray-400 text-sm" data-id="element-272">
              &copy; {currentYear} SmartSoda, Inc. All rights reserved.
            </p>
            <p className="text-gray-500 text-xs" data-id="element-273">
              Committed to creating delicious beverages with sustainable
              practices.
            </p>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;